const e = "_modalOverlay_1x29r_2", r = "_innerWrapper_1x29r_10", n = "_videoWrapper_1x29r_36", a = "_innerVideoWrapper_1x29r_51", o = "_nativeVideo_1x29r_58", p = {
  modalOverlay: e,
  innerWrapper: r,
  videoWrapper: n,
  innerVideoWrapper: a,
  nativeVideo: o
};
export {
  p as default,
  a as innerVideoWrapper,
  r as innerWrapper,
  e as modalOverlay,
  o as nativeVideo,
  n as videoWrapper
};
